/* eslint-disable react/no-danger */
import React from 'react'
import classes from '@src/styles/disposal/featureList.module.css'

export type FeatureListProps = {
  heading: string
  list: { heading: string; content: string }[]
}

function FeatureList({ heading, list }: FeatureListProps) {
  return (
    <section>
      <div className={classes.listContainer}>
        <div>
          <h2 className={classes.listTitle} dangerouslySetInnerHTML={{ __html: heading }} />
          <div className={classes.listItemContainer}>
            <ul className={classes.list}>
              {list.map((item: { heading: string; content: string }) => (
                <li key={item.heading} className={classes.listItem}>
                  <span>{item.heading}</span> {item.content}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FeatureList
